import { Component, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastService } from 'src/app/core/services/toast.service';
import { ToastModel } from '../models/toast.model';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnDestroy {
    private _toastService = inject(ToastService);

    private $subsciption: Subscription;
    public toastModel!: ToastModel;

    constructor() {
        this.$subsciption = this._toastService.$toastState.subscribe((toastModel: ToastModel) => {
            this.toastModel = toastModel;
        })
    }

    public close(): void {
        // TODO: Make this a fade transition.
        this.toastModel.visible = false;
    }

    ngOnDestroy(): void { this.$subsciption.unsubscribe(); }
}